"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTag = void 0;
const getTag = ({ httpClient, }) => ({ tag_name, }) => {
    const path = '/tags';
    const url = `${path}/${tag_name}`;
    return httpClient.get(url);
};
exports.getTag = getTag;
//# sourceMappingURL=get-tag.js.map